import { Component, Input, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { countriesWithoutLocalAndDistrictTax, countriesWithTaxSummary } from 'core/app-info/country-specifics.enum';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-invoice-footer',
  templateUrl: './invoice-footer.component.html',
  styleUrls: ['./invoice-footer.component.scss'],
  standalone: false
})
export class InvoiceFooterComponent implements OnInit {
  appStrings: AppLocalization;
  dateFormat = this.appInfoService.dateFormat;
  invoiceFooterResult;
  countriesWithoutLocalAndDistrictTaxes;
  countryCode;
  showTaxSummary;
  @Input() currencySymbol;
  @Input() invoiceNumber: string;
  isAustralia = false;

  constructor(
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.countriesWithoutLocalAndDistrictTaxes = countriesWithoutLocalAndDistrictTax;
    this.countryCode = this.appInfoService.userData.UserInfo.CountryCode;
    if (this.countryCode === 'AU') {
      this.isAustralia = true;
    }
    this.showTaxSummary = countriesWithTaxSummary[this.countryCode];
    this.invoicesService.getInvoiceFooter(this.invoiceNumber, invoiceFooter => {
      this.invoiceFooterResult = invoiceFooter;
    });
  }

  /**
   * Formats the remit-to information for display.
   */
  public formatRemitTo(values: string[], separator = ' | '): string {
    return values.filter(value => value && value.trim()).join(separator);
  }
}
